import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PUBLIC_SYSTEM_SETTINGS_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpPartialSuccess, hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetSystemSettingsRequestPayload,
  GetSystemSettingsResult,
  SystemSettings,
} from '../types/getSystemSettings.types';

export const getSystemSettings = (builder: BuilderType) =>
  builder.query<SystemSettings[], GetSystemSettingsRequestPayload>({
    providesTags: ['SystemSettings'],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_PUBLIC_SYSTEM_SETTINGS_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetSystemSettingsResult>) => {
      if (hasCcdpSuccess(response) || hasCcdpPartialSuccess(response)) {
        return response.Result.SystemSettings;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
